import { render, staticRenderFns } from "./CountriesSelect.vue?vue&type=template&id=fa734b5e&"
import script from "./CountriesSelect.vue?vue&type=script&lang=js&"
export * from "./CountriesSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports